// extracted by mini-css-extract-plugin
module.exports = {"Btn":"CopyToClipboardButton_Btn__2WSa6"};